import React, { useState, useEffect } from "react";
import axios from "axios";
import DataTable from "react-data-table-component";
import moment from "moment";
import $ from "jquery";
import "daterangepicker/daterangepicker.css";
import "daterangepicker";
import { CSVLink } from "react-csv";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;



const ExpiredUserSearch = () => {
  const [startDate, setStartDate] = useState(moment().format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(moment().format("YYYY-MM-DD"));
    const [mobileno, setMobileno] = useState("");
    const [userid, setUserid] = useState("");
    const [username, setUsername] = useState("");
    const [planname, setPlanname] = useState("");
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
      const [userDetails, setUserDetails] = useState(null);
                const [isModalOpen, setIsModalOpen] = useState(false);
                                              const [expandedPlanIndex, setExpandedPlanIndex] = useState(null);
                

    useEffect(() => {
        fetchData();
    }, [startDate, endDate, mobileno, userid, username, planname]);


        // useEffect(() => {
        //                                             document.title = 'Expired User Search - Calendar Services';
        //                                           }, []);


        useEffect(() => {
            document.title = 'Expired User Search - Calendar Services';
        
            // Initialize the date range picker
            $("#kt_daterangepicker_4").daterangepicker(
                {
                    startDate: moment(),
                    endDate: moment(),
                    
                    ranges: {
                        'Expired Yesterday': [moment().subtract(1, 'days'), moment().subtract(1, 'days')],
                        'Expired 3 Days': [moment().subtract(2, 'days'), moment().subtract(1, 'days')], // End date set to yesterday
                        'Expired 7 Days': [moment().subtract(6, 'days'), moment().subtract(1, 'days')], // End date set to yesterday
                        'Expired 15 Days': [moment().subtract(14, 'days'), moment().subtract(1, 'days')], // End date set to yesterday
                        'Expired All': [moment().subtract(4, 'year').startOf('month'), moment()]
                    }
                },
                (start, end) => {
                    setStartDate(start.format("YYYY-MM-DD"));
                    setEndDate(end.format("YYYY-MM-DD"));
                    $("#kt_daterangepicker_4").html(`${start.format("MMMM D, YYYY")} - ${end.format("MMMM D, YYYY")}`);
                }
            );
        
            // Set initial display value
            $("#kt_daterangepicker_4").html(
                `${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`
            );
        }, []);
        



    const fetchData = async () => {
        setLoading(true);
        try {
            // const response = await axios.post("http://localhost:3036/expired_user_search", {
                const response = await axios.post(`${API_BASE_URL}/expired_user_search`,{

                startDate,
                endDate,
                mobileno,
                userid,
                username,
                planname,
            });
            setData(response.data);
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
        }
    };

    // const handleViewDetails = async (userid) => {
    //     setLoading(true);
    //     try {
    //         // const response = await axios.post("http://localhost:3036/registered_users/details_userid", { id: userid });
    //         const response = await axios.post(`${API_BASE_URL}/registered_users/details_userid`, { id: userid });

    //         setUserDetails(response.data);
    //         setIsModalOpen(true);
    //     } catch (error) {
    //         console.error("Error fetching user details:", error);
    //         alert("Failed to fetch user details.");
    //     } finally {
    //         setLoading(false);
    //     }
    // };

    const handlePlanClick = (index) => {
        setExpandedPlanIndex(expandedPlanIndex === index ? null : index);
      };

    const handleViewDetails = async (row) => {
        setLoading(true);
        try {
            const payload = { 
                name: row.name,   
                type: row.type, 
                mobileNo: row.mobileno 
            };
              // const response = await axios.post("http://localhost:3036/registered_users/details_userid", { id: userid });
             const response = await axios.post(`${API_BASE_URL}/registered_users/details_userid_new`,payload);
  
              setUserDetails(response.data);
              setIsModalOpen(true);
          } catch (error) {
              console.error("Error fetching user details:", error);
              alert("Failed to fetch user details.");
          } finally {
              setLoading(false);
          }
      };

    const closeModal = () => {
        setIsModalOpen(false);
        setUserDetails(null);
    };


    const csvHeaders = [
        { label: "SlNo", key: "slNo" },
        { label: "User ID", key: "userid" },
        { label: "Name/District/City", key: "nameDistrictCity" },
        { label: "Mobile No", key: "mobileno" },
        { label: "Type", key: "type" },
        { label: "Plan Name", key: "planname" },
        { label: "View Count", key: "viewcount" },
        { label: "Call Count", key: "callcount" },
        { label: "Reg Date", key: "adddate" },
        { label: "Plan End Date", key: "end_date" },
    ];




    const columns = [
        { name: "SlNo", selector: (row, index) => index + 1, sortable: true },
        {
            name: "Actions",
            cell: (row) => (
                <button
                    onClick={() => handleViewDetails(row)}
                    className="btn btn-warning bg-red-200"
                >
                    View Details
                </button>
            ),
        },
        { name: "User ID", selector: (row) => row.userid, sortable: true }, // Updated to match 'userid' key
        { 
            name: "Name/District/City", 
            selector: (row) => `${row.name}/${row.district}/${row.city}`, 
            sortable: true 
        },
        { name: "Mobile No", selector: (row) => row.mobileno, sortable: true },
        {
            name: "Type",
            selector: (row) => row.type,
            cell: (row) => (
                <span
                    style={{
                        background: row.typeColor,
                        padding: "5px",
                        color: "#fff",
                        borderRadius: "4px",
                    }}
                >
                    {row.type}
                </span>
            ),
            sortable: true,
        },
        { name: "Plan Name", selector: (row) => row.planname, sortable: true },
        { name: "View Count", selector: (row) => row.viewcount, sortable: true },
        { name: "Call Count", selector: (row) => row.callcount, sortable: true },
        { name: "Reg Date", selector: (row) => row.adddate, sortable: true }, // Updated to match 'adddate' key
        { name: "cby", selector: (row) => row.cby, sortable: true },

        { name: "Plan End Date", selector: (row) => row.end_date, sortable: true },
        { name: "Action", cell: (row) => <button onClick={() => openModel(row.userid)}>View</button> },
    ];
    

    const openModel = (id) => {
        // Logic to open modal and fetch user details
    };

    return (
        <div className="max-w-6xl mx-auto mt-8 bg-white">
            <h2 className="text-2xl font-bold mb-9 text-center">Expired User Search</h2>
           {/* Container for search fields */}
           <div className="flex items-center gap-2 mb-6 flex-wrap justify-between">
  {/* Date Range Picker */}
  <div className="flex items-center space-x-2">
    <div
      id="kt_daterangepicker_4"
      className="bg-white border px-4 py-2 rounded cursor-pointer"
    >
      {`${moment().format("MMMM D, YYYY")} - ${moment().format("MMMM D, YYYY")}`}
    </div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="h-5 w-5 text-gray-500"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M8 7V3m8 4V3m-6 4h6m4 0a2 2 0 012 2v10a2 2 0 01-2 2H6a2 2 0 01-2-2V9a2 2 0 012-2h12z"
      />
    </svg>
  </div>

  {/* Mobile No */}
  <div className="flex flex-col">
    <label htmlFor="mobileno" className="text-sm font-medium">Mobile No:</label>
    <input
      type="text"
      id="mobileno"
      value={mobileno}
      onChange={(e) => setMobileno(e.target.value)}
      className="border border-gray-300 rounded-md p-2"
      placeholder="Enter Mobile Number"
    />
  </div>

  {/* User ID */}
  <div className="flex flex-col">
    <label htmlFor="userid" className="text-sm font-medium">User ID:</label>
    <input
      type="text"
      id="userid"
      value={userid}
      onChange={(e) => setUserid(e.target.value)}
      className="border border-gray-300 rounded-md p-2"
      placeholder="Enter User ID"
    />
  </div>

  {/* Username */}
  <div className="flex flex-col">
    <label htmlFor="username" className="text-sm font-medium">Username:</label>
    <input
      type="text"
      id="username"
      value={username}
      onChange={(e) => setUsername(e.target.value)}
      className="border border-gray-300 rounded-md p-2"
      placeholder="Enter Username"
    />
  </div>

  {/* Plan Name */}
  <div className="flex flex-col">
    <label htmlFor="planname" className="text-sm font-medium">Plan Name:</label>
    <input
      type="text"
      id="planname"
      value={planname}
      onChange={(e) => setPlanname(e.target.value)}
      className="border border-gray-300 rounded-md p-2"
      placeholder="Enter Plan Name"
    />
  </div>
</div>



             <div className="flex justify-end mb-5">
                            <CSVLink
                                data={data}
                                headers={csvHeaders}
                                filename="Expired_search_list.csv"
                                className="bg-green-500 text-white px-4 py-2 rounded-md"
                            >
                                Export to Excel
                            </CSVLink>
                        </div>



            {loading ? (
                <p className="text-center mt-4">Loading...</p>
            ) : (

                
                <DataTable
                    columns={columns}
                    data={data}
                    pagination
                    highlightOnHover
                    className="mt-6"
                />

            )}
             {isModalOpen && userDetails && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center">
            <div
                className="bg-white p-6 rounded-lg max-w-4xl w-full overflow-y-auto"
                style={{ maxHeight: "80vh" }}
            >
                <h3 className="text-xl font-bold mb-4 text-center text-blue-700">User Details</h3>
                <div className="grid grid-cols-2 gap-4">
                    <p><strong>Name:</strong> {userDetails.name}</p>
                    <p><strong>Mobile No:</strong> <span style={{ color: "green" }}>{userDetails.mobileNo}</span></p>
                    <p><strong>Gender:</strong> {userDetails.gender || "-"}</p>
                    <p><strong>Type:</strong> {userDetails.type}</p>
                    <p><strong>Category:</strong> {userDetails.category || "-"}</p>
                    <p><strong>District:</strong> {userDetails.district}</p>
                    <p><strong>City:</strong> {userDetails.city}</p>
                    <p><strong>Education:</strong> {userDetails.education}</p>
                    <p><strong>Experience:</strong> {userDetails.experience} years</p>
                    <p><strong>Address:</strong> {userDetails.address || "-"}</p>
                    {/* <p><strong>E-mail:</strong> {userDetails.email || "-"}</p> */}
                    <p><strong>Other Details:</strong> {userDetails.otherDetails || "-"}</p>
                    <p><strong>Web Link:</strong> <a href={userDetails.webLink} target="_blank" rel="noopener noreferrer">{userDetails.webLink}</a></p>
                    <p><strong>YouTube Link:</strong> <a href={userDetails.youtubeLink} target="_blank" rel="noopener noreferrer">{userDetails.youtubeLink}</a></p>
                    <p><strong>Facebook Link:</strong> <a href={userDetails.facebookLink} target="_blank" rel="noopener noreferrer">{userDetails.facebookLink}</a></p>
                </div>
                <div className="mt-4 grid grid-cols-2 gap-4">
                    
                    <div>
                        
                        <strong>Image 1:</strong>
                        {userDetails.image1 && (
                            <img
                            src={`${API_BASE_URL}/${userDetails.image1}`} 
                            alt="Image 1"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Image 2:</strong>
                        {userDetails.image2 && (
                            <img
                            src={`${API_BASE_URL}/${userDetails.image2}`} 
                            alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>ID proof</strong>
                        {userDetails.idproof && (
                            <img
                                src={userDetails.idproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Address Proof</strong>
                        {userDetails.addressproof && (
                            <img
                                src={userDetails.addressproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                    <div>
                        <strong>Other Proof</strong>
                        {userDetails.otherproof && (
                            <img
                                src={userDetails.otherproof}
                                alt="Image 2"
                                className="w-40 h-40 object-cover"
                            />
                        )}
                    </div>
                </div>


                <div className="mt-4">
      <h2 className="text-xl font-bold mb-4">Plans</h2>
      {userDetails.plans && userDetails.plans.length > 0 ? (
        userDetails.plans.map((plan, index) => (
          <div
            key={index}
            onClick={() => handlePlanClick(index)} // Click handler on the card
            className={`border border-gray-300 rounded-lg shadow-lg p-4 mb-4 cursor-pointer ${
              expandedPlanIndex === index ? "bg-gray-100" : "bg-white"
            }`} // Styling for active and inactive cards
          >
            {/* Card Header */}
            <div className="flex justify-between items-center">
              <h3 className="text-lg font-semibold">{plan.name}</h3>
              <button
  className="text-blue-500 underline"
  onClick={(e) => {
    e.stopPropagation(); // Prevent card click from triggering
    const userId = plan.userId || userDetails.id; // Ensure userId is correctly assigned
    if (userId) {
      window.open(`${API_BASE_URL}/generate_invoice/${userId}`, "_blank"); // Open in a new tab
    } else {
      alert("User ID is missing. Unable to generate invoice.");
    }
  }}
>
  Invoice PDF
</button>

            </div>

            {/* Card Details */}
            {expandedPlanIndex === index && (
              <div className="mt-4">
                <div className="flex justify-between">
                  <p>
                    <strong>Start Date:</strong> {plan.startDate}
                  </p>
                  <p>
                    <strong>End Date:</strong> {plan.endDate}
                  </p>
                </div>
                <p className="mt-2">
                  <strong>Invoice Number:</strong> {plan.invoiceNumber}
                </p>
                <div className="mt-4 border-t border-gray-200 pt-4">
                  <p>
                    <strong>Actual Amount:</strong> ₹{plan.actualAmount} /-
                  </p>
                  <p>
                    <strong>GST Amount (18%):</strong> ₹{plan.gstAmount} /-
                  </p>
                  <p>
                    <strong>Total Amount:</strong> ₹{plan.totalAmount} /-
                  </p>
                </div>
              </div>
            )}
          </div>
        ))
      ) : (
        <p>No plans available</p>
      )}
    </div>

    
                {/* <div className="mt-6 text-center">
                    <button className="btn btn-primary mx-2">Edit</button>
                    <button className="btn btn-success mx-2">Verify</button>
                    <button className="btn btn-danger mx-2">Inactive</button>
                    <button className="btn btn-warning mx-2">Delete</button>
                    <button className="btn btn-info mx-2">Follow Up</button>
                </div> */}

                <div className="mt-4 text-center">
                    <button onClick={closeModal} className="btn btn-secondary text-red-500">Close</button>
                </div>
            </div>
        </div>
    )}
        </div>
    );
};

export default ExpiredUserSearch;